import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const LeftArrow = createSvgIcon(
  <path d="m11.25 3.75 1.59 1.59-5.079 5.08h12.783v2.25H7.762l5.08 5.079-1.593 1.591-7.794-7.796 7.794-7.795Z" />,
  'LeftArrow'
);

export { LeftArrow };
